import React, { useState } from "react";
import { Link } from "react-router-dom";

function ProductCard({ product }) {
  
  return (
    <>
      <div className="card shadow-sm item-card">
        <div className="card-header">{checkDiscount(product)}</div>
        <div className="card-body d-flex justify-content-center align-items-center">
          <div className="text-center">
            <Link to={"/ProductDetails/"+product.product_code}>
              <img src={product.image} />
              <h6 className="mt-3 text-dark">{product.title}</h6>
              <p className="text-secondary">
                {product.unit_price} টাকা/{product.unit}
              </p>
            </Link>
            <Link to={"/ProductDetails/"+product.product_code} className="btn btn-warning">অর্ডার করুন</Link>
          </div>
        </div>
      </div>
    </>
  );
}

const checkDiscount = ({
  stock,
  discount_type,
  discount_percentage,
  flat_discount,
}) => {
  if (stock === "NO") return "স্টক আউট";
  if (stock === "CS") return "শীঘ্রই আসছে";
  if (stock === "YES" && discount_type === "Percentage")
    return `${discount_percentage}  % অফ`;
  if (stock === "YES" && discount_type === "Flat")
    return `${flat_discount} টাকা ডিস্কাউন্ট`;
  return "";
};

export default ProductCard;
